import { campaignDate, isScheduled, localDay } from '../Dashboard/overviewData';

export function campaignStatus(campaign, now) {
  return isScheduled(campaign, now) ? 'scheduled' : ({ Queued: 'queued', 'In progress': 'in_progress',
    'Emails Sent': 'emails_sent', Completed: 'completed', Created: 'created' })[campaign.status] || 'unknown';
}
export function sendingErrors(campaign) {
  const value = campaign.stats.error;
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}
export function filterCampaignList(campaigns, { query, days, errors }, now) {
  const from = new Date(now);
  if (days !== 'all') from.setDate(from.getDate() - Number(days) + 1);
  const firstDay = localDay(from), lastDay = localDay(now), search = query.trim().toLocaleLowerCase();
  return campaigns.filter(item => item.name.toLocaleLowerCase().includes(search) &&
    (days === 'all' || (localDay(item.created_date) >= firstDay && localDay(item.created_date) <= lastDay)) &&
    (!errors || sendingErrors(item) > 0));
}
export function sortCampaignList(campaigns, key, descending, locale) {
  const value = item => key === 'rate' ? (item.stats.sent ? item.stats.clicked / item.stats.sent : -1)
    : key === 'name' ? item.name : campaignDate(item.launch_date)?.getTime() || 0;
  return [...campaigns].sort((a, b) => {
    const av = value(a), bv = value(b), order = key === 'name' ? av.localeCompare(bv, locale) : av - bv;
    return (order || a.id - b.id) * (descending ? -1 : 1);
  });
}

// Retain names, never result/event payloads. Bound requests across page changes.
export function createTemplateNameLoader(fetchDetails, concurrency = 3) {
  const cache = new Map(), queue = [];
  let running = 0, disposed = false;
  function drain() {
    while (!disposed && running < concurrency && queue.length) {
      const job = queue.shift(); running++;
      Promise.resolve().then(() => fetchDetails(job.id)).then(value => {
        job.resolve(typeof value?.template?.name === 'string' ? value.template.name : null);
      }, error => { cache.delete(job.id); job.reject(error); }).finally(() => { running--; drain(); });
    }
  }
  return {
    load(id) {
      if (disposed) return Promise.reject(new Error('List unmounted'));
      if (!cache.has(id)) {
        const promise = new Promise((resolve, reject) => queue.push({ id, resolve, reject }));
        cache.set(id, promise); drain();
      }
      return cache.get(id);
    },
    dispose() { disposed = true; queue.splice(0).forEach(job => job.reject(new Error('List unmounted'))); cache.clear(); }
  };
}
